import React, { useEffect, useState } from 'react';
import '../Styles/Reels/ReelsRight.css';
import Share from '../Views/User/Reels/Share';
import Comments from '../Views/User/Reels/Comments';
import FavoriteIcon from '@mui/icons-material/Favorite';
import authMiddleware from './authMiddleware';
import OrderPopop from './OrderPopop';
import UnMuteIcon from '../assets/svg/unMuteIcon';
import MuteIcon from '../assets/svg/muteIcon';
import SaveIcon from '../assets/svg/saveIcon';
import ShareIcon from '../assets/svg/shareIcon';
import CommentIcon from '../assets/svg/commentIcon';
import axiosUserInstance from '../axiosUserInstance';
import { useMute } from '../MuteContext';
import { getOpenStatusFromAPI } from '../OpenStatus';
import { ClickAwayListener, Tooltip, useMediaQuery } from '@mui/material';
import { useNotifications } from '../Views/User/Notification/NotificationContext';
function ReelsRight(props) {
    const {
        id,
        vendorID,
        restaurantName,
        isLike,
        setIsLike,
        getLikes,
        likesCount,
        commentsCount,
        commentsList,
        setCommentsList,
        getComments,
        isVideoFile,
        url,
        reelsId,
        restaurant,
        saveFlag,
        animateModal,
        setClosing,
        closing,
        setAnimateModal,
        rating,
        setCommentsCount,
        vendorAddress,
        vendorDistance,
        user_Rating_count,
    } = props;
    const [openPopop, setOpenPopop] = useState(false);
    const [showCommentPopup, setShowCommentPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isFilled, setIsFilled] = useState(false);
    const [openShare, setOpenShare] = useState(false);
    const [vendorStatus, setVendorStatus] = useState();
    const [vendorOpeningTime, setVendorOpeningTime] = useState();
    const [vendorOpeningDay, setVendorOpeningDay] = useState();
    const vendorNames = restaurant?.map((vendor) => vendor?.Vendor_Info?.[0]);
    const handleOpenShare = () => setOpenShare(true);
    const handleCloseShare = () => setOpenShare(false);
    const [pickupTooltipOpen, setPickupTooltipOpen] = useState(false);
    const { isMuted, toggleMute, setIsMuted } = useMute();
    const isMobile = useMediaQuery('(max-width:600px)');
    const [tooltipOpen, setTooltipOpen] = useState(false);
    const { addNotification } = useNotifications();
    const handleTooltipOpen = () => {
        if (vendorStatus !== 'open') {
            setTooltipOpen(true);
            setTimeout(() => {
                setTooltipOpen(false);
            }, 3000);
        }
    };
    
    const handleTooltipClose = () => {
        setTooltipOpen(false);
    };
    
    const handleOpenCommentPopup = () => {
        if (!authMiddleware()) {
            return;
        }
        setAnimateModal(false);
        setShowCommentPopup(true);
        setIsMuted(true);

        setTimeout(() => {
            setAnimateModal(true);
        }, 100);
    };

    const checkStatus = () => {
        getOpenStatusFromAPI(vendorID)
            .then((data) => {
                setVendorStatus(data.status);
                setVendorOpeningTime(data.nextOpenTime);
                setVendorOpeningDay(data.nextOpenDay);
            })
            .catch((error) => {
                console.error('Error checking status:', error);
            });
    };

    useEffect(() => {
        checkStatus();
    }, []);
    
    const handleCloseCommentPopup = () => setShowCommentPopup(false);

    useEffect(() => {
        if (saveFlag !== undefined) {
            setIsFilled(saveFlag === 'true' || saveFlag === true);
        }
    }, [saveFlag]);

    const handleSaveClick = async () => {
        if (!authMiddleware()) {
            return;
        }

        if (loading) return;
        setLoading(true);

        const toggleState = !isFilled;
        const postData = {
            Post_id: id,
            toggle: toggleState,
        };

        try {
            const res = await axiosUserInstance.post('/post/savepost', postData);

            if (res?.status === 200 || res?.status === 201) {
                setIsFilled(toggleState);
            } else {
                console.error('Unexpected response from server');
            }
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleOrderClick = () => {
        setOpenPopop(!openPopop);
        setIsMuted(true);
    };
    const handleLike = async () => {
        if (!authMiddleware()) {
            return;
        }

        if (loading) return;
        setLoading(true);

        

        const newLikeState = !isLike;
        const LikePost = {
            toggle_like: newLikeState,
        };

        try {
            const res = await axiosUserInstance.post(
                `/customers/likes/account/userid/post/${id}`,
                LikePost,
               
            );

            if (res?.status === 200 || res?.status === 201) {
                setIsLike(newLikeState);
                await getLikes();

                if (newLikeState) {
                    const notificationPayload = {
                        from_user_id: 1,
                        // to_user_id:, // I noticed `to_user_id` should likely be the post owner
                        type: 'like',
                        action_id: id, // `action_id` should probably be the post id
                        notification_boundary: 'private',
                        is_read: false,
                    };

                    console.log('Sending notification:', notificationPayload);
                    await addNotification(notificationPayload); // Ensure async if needed
                }
            } else {
                console.error('Unexpected response from server', res);
            }
        } catch (error) {
            console.error('API Error:', error);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div>
            <div className="right-container">
                <div className="icons">
                    {isVideoFile(url) && (
                        <div>
                            {isMuted ? (
                                <MuteIcon className="mute" onClick={toggleMute} />
                            ) : (
                                <UnMuteIcon className="mute" onClick={toggleMute} />
                            )}

                        </div>
                    )}
                    <div className="svg-text-container">
                        <FavoriteIcon
                            fontSize="large"
                            className="like-svg-icon"
                            style={{
                                color: isLike ? 'red' : 'white',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                fontSize: '35px',
                            }}
                            onClick={loading ? null : handleLike}
                        />
                        <p className="paragraph-color">{likesCount ? likesCount : '0'}</p>
                    </div>
                    <div className="svg-text-container" style={{ gap: '4px' }}>
                        <CommentIcon handleOpenCommentPopup={handleOpenCommentPopup} />
                        {showCommentPopup && (
                            <Comments
                                id={id}
                                open={showCommentPopup}
                                handleClose={handleCloseCommentPopup}
                                commentsList={commentsList}
                                setCommentsList={setCommentsList}
                                getComments={getComments}
                                animateModal={animateModal}
                                setClosing={setClosing}
                                closing={closing}
                                setAnimateModal={setAnimateModal}
                                setCommentsCount={setCommentsCount}
                            />
                        )}

                        <p className="paragraph-color">
                            {commentsCount ? commentsCount : '0'}
                        </p>
                    </div>

                    <div className="svg-text-container">
                        <ShareIcon handleOpenShare={handleOpenShare} />
                        {openShare && (
                            <Share
                                handleClose={handleCloseShare}
                                open={openShare}
                                url={
                                    /\/reels\/\d+$/.test(window.location.href)
                                        ? window.location.href
                                        : `${window.location.href.replace(/\/(search|profile)/, '/reels')}/${reelsId}`
                                }
                            />
                        )}
                    </div>
                    <div className="svg-text-container" style={{ color: 'white' }}>
                        <SaveIcon
                            loading={loading}
                            handleSaveClick={handleSaveClick}
                            isFilled={isFilled}
                        />
                    </div>
                </div>
             
                {isMobile && vendorStatus !== 'open' ? (
                    <ClickAwayListener onClickAway={handleTooltipClose}>
                        <Tooltip
                            onClose={handleTooltipClose}
                            open={tooltipOpen}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title={`Oops! ${restaurantName} is taking a break. They’ll be back ${
                                (vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'
                            }.`}
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#E13535',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                        lineHeight: '20px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#E13535',
                                    },
                                },
                            }}
                            arrow
                        >
                            <button
                                className="order-btn"
                                style={{ marginBottom: '20px' }}
                                onClick={handleTooltipOpen}
                            >
                Order
                            </button>
                        </Tooltip>
                    </ClickAwayListener>
                ) : isMobile && vendorStatus === 'open' && vendorDistance > 20 ? (
                    <ClickAwayListener onClickAway={() => setPickupTooltipOpen(false)}>
                        <Tooltip
                            onClose={() => setPickupTooltipOpen(false)}
                            open={pickupTooltipOpen}
                            disableFocusListener
                            disableHoverListener
                            disableTouchListener
                            title="Only pickup available."
                            componentsProps={{
                                tooltip: {
                                    sx: {
                                        backgroundColor: '#E13535',
                                        color: '#ffffff',
                                        fontSize: '16px',
                                        lineHeight: '20px',
                                        borderRadius: '6px',
                                    },
                                },
                                arrow: {
                                    sx: {
                                        color: '#E13535',
                                    },
                                },
                            }}
                            arrow
                        >
                            <button
                                className="order-btn"
                                style={{ marginBottom: '20px' }}
                                onClick={() => {
                                    setPickupTooltipOpen(true);
                                    setTimeout(() => {
                                        setPickupTooltipOpen(false);
                                    }, 2000);
                                    setTimeout(() => {
                                        handleOrderClick(restaurantName);
                                    }, 1000);
                                }}
                            >
                Order
                            </button>
                        </Tooltip>
                    </ClickAwayListener>
                ) : vendorStatus === 'open' && vendorDistance > 20 ? (
                    <Tooltip
                        title="Only pickup available."
                        arrow
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#E13535',
                                    color: '#ffffff',
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                    borderRadius: '6px',
                                },
                            },
                            arrow: {
                                sx: {
                                    color: '#E13535',
                                },
                            },
                        }}
                    >
                        <button
                            className="order-btn"
                            style={{ marginBottom: '20px' }}
                            onClick={() => handleOrderClick(restaurantName)}
                        >
            Order
                        </button>
                    </Tooltip>
                ) : vendorStatus === 'open' ? (
                    <button
                        className="order-btn"
                        style={{ marginBottom: '20px' }}
                        onClick={() => handleOrderClick(restaurantName)}
                    >
        Order
                    </button>
                ) : (
                    <Tooltip
                        title={`Oops! ${restaurantName} is taking a break. They’ll be back ${
                            (vendorOpeningTime && vendorOpeningDay) ? `at ${vendorOpeningDay} ${vendorOpeningTime}` : 'soon'
                        }.`}
                        arrow
                        componentsProps={{
                            tooltip: {
                                sx: {
                                    backgroundColor: '#E13535',
                                    color: '#ffffff',
                                    fontSize: '16px',
                                    lineHeight: '20px',
                                    borderRadius: '6px',
                                },
                            },
                            arrow: {
                                sx: {
                                    color: '#E13535',
                                },
                            },
                        }}
                    >
                        <button
                            className="order-btn"
                            style={{ marginBottom: '20px' }}
                            disabled
                        >
            Order
                        </button>
                    </Tooltip>
                )}

            </div>

            <div>
                {openPopop && (
                    <OrderPopop
                        restaurantName={restaurantName}
                        handleClose={() => {
                            setTimeout(() => {
                                setOpenPopop(!openPopop);
                            }, 500);
                        }}
                        restaurant={vendorNames}
                        vendorID={vendorID}
                        rating={rating}
                        vendorAddress={vendorAddress}
                        vendorDistance={vendorDistance}
                        user_Rating_count={user_Rating_count}
                    />
                )}
            </div>
        </div>
    );
}

export default ReelsRight;
